import { render, staticRenderFns } from "./GoodReviewPrice.vue?vue&type=template&id=39d971ac&scoped=true&"
import script from "./GoodReviewPrice.vue?vue&type=script&lang=js&"
export * from "./GoodReviewPrice.vue?vue&type=script&lang=js&"
import style0 from "./GoodReviewPrice.vue?vue&type=style&index=0&id=39d971ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d971ac",
  null
  
)

export default component.exports